<template>
  <div class="app-container-v2 table-container-v2 has-tabs">
    <div class="title-box">
      <div class="title-left" :style="{ visibility: render ? 'visible' : 'hidden' }">
        <select-cus @change="cusChange"></select-cus>
        <div class="date-picker-v2" :class="{ ml16: cusListTotal.length > 1 }">
          <el-date-picker class="query-date-picker" v-model="wageMonthRange" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" :start-placeholder="$t('from')" :end-placeholder="$t('to')" @change="getData"></el-date-picker>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.idCards" multiple collapse-tags :placeholder="$t('selectStaff')" filterable clearable @change="handleSelectChange" @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.emp" :key="item.id" :value="item.idCard" :label="item.empName" />
          </el-select>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.costCenters" multiple collapse-tags :placeholder="$t('selectCostCenter')" filterable clearable @change="handleSelectChange" @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.costCenter" :key="item.id" :value="item.costName" :label="item.costName" />
          </el-select>
        </div>
        <div class="select-v2">
          <el-input class="query-select" v-model="queryParams.empNOs"
                    placeholder="请输入雇员编号，多个以,间隔"></el-input>
        </div>
        <div class="select-v2">
          <el-input class="query-select" v-model="queryParams.empNames"
                    placeholder="请输入雇员姓名，多个以,间隔"></el-input>
        </div>
        <div class="select-v2" v-if="this.queryParams.cusId==='9999011700'||this.queryParams.cusId==='9999013144'">
          <el-input class="query-select" v-model="queryParams.taxGroupNames"
                    placeholder="请输入报税组合"></el-input>
        </div>
        <div v-if="false" class="date-picker-v2">
          <el-date-picker v-model="queryParams.wageMonths" type="months" format="yyyy-MM" value-format="yyyy-MM" :placeholder="$t('salaryMonth')" prefix-icon="none" @change="getData"></el-date-picker>
          <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
        </div>
        <div class="select-v2">
          <el-button type="primary" class="button-v2" @click="handleSelect">{{ $t('query') }}</el-button>
        </div>
      </div>
      <div class="title-right">
        <el-button plain class="button-v2" @click="customHeaderModalShow = true">{{ $t('displayItemConfiguration') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleExport">{{ $t('export') }}</el-button>
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <el-tabs v-model="tabIndex" type="card" @tab-click="changeTab">
        <el-tab-pane
          style="height: calc(100vh - 250px);"
          lazy
          :key="item.taxType"
          v-for="(item, index) in taxGroupCountList"
          :label="item.taxTypeName"
          :name="'tab'+index"
        >
          <span slot="label">{{item.taxTypeName}}<el-badge :value="item.taxTypeCount"></el-badge></span>
        </el-tab-pane>
      </el-tabs>
      <div class="table-body-tabs-content flex vertical jbetween">
        <div class="table-body-table">
          <air-table
            v-if="render"
            ref="airTable"
            class="table-v2"
            :show-checkbox="false"
            :show-operation="false"
            align="center"
            :columns="columns"
            :data="tableData"
            show-footer
            :footer-method="footerMethod"
            @change-filter="changeFilter"
          ></air-table>
        </div>
        <bsp-pagination :pager-config.sync="queryParams" @page-change="getData" @page-size-change="pageSizeChange" show-page-size></bsp-pagination>
      </div>
    </div>
    
    <el-dialog
      class="modal-v2 has-padding"
      width="800px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('displayItemConfiguration')"
      :visible.sync="customHeaderModalShow"
      append-to-body
    >
      <customHeader :header-list.sync="headerList" report-type="员工收入明细表"></customHeader>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="customHeaderModalShow = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="saveCustomHeader">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as api from '@/api/v2/stats/emp-income'
  import {queryEmpInfoListPage} from '@/api/v2/common'
  import {randomLenNum, downloadFileByUrl} from '@/util/util';
  import customHeader from '@/components/v2/custom-header'
  import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
  import {updataCustHeaderInfo} from '@/api/wage/pay'
  import {mapGetters} from 'vuex';
  import {floatSumArray} from '@/util/util';
  import {validatenull} from '@/util/validate';
  
  export default {
    name: 'EmpIncomeDetail',
    components: {
      customHeader,
      SelectCus
    },
    data() {
      return {
        render: false,
        loading: true,
        wageMonthRange: [],
        isSelectChange: false,
        queryParams: {
          startDate: undefined,
          endDate: undefined,
          idCards: [],
          costCenters: [],
          taxTypes: [],
          empNOs: '',
          empNames: '',
          taxGroupNames: '',
          cusIds: [],
          tags: 'tags',
          page: 1,
          limit: 20,
          total: 0
        },
        limitCustom: 1,
        dictMap: {},
        dictData: {
          emp: [],
          costCenter: [],
          taxType: []
        },
        columns: [],
        tableData: [],
        taxGroupCountList: [],
        tabIndex: 'tab0',
        submitLoading: false,
        customHeaderModalShow: false,
        headerList: []
      }
    },
    computed: {
      ...mapGetters(['cusListTotal'])
    },
    created() {
      const storeParams = this.$getStore('empIncomeDetail_queryParams')
      if (storeParams) {
        // 如果缓存中有参数，则说明是从汇总点击查看明细而来
        this.queryParams = storeParams
        this.$removeStore('empIncomeDetail_queryParams')
      }
      this.init()
    },
    methods: {
      init() {
        this.queryParams.cusId = this.$userInfo.cusId
        this.getEmpList()
        this.getData()
      },
      getData() {
        this.render = false
        this.loading = true
        if (this.$isNotEmpty(this.wageMonthRange)) {
          this.queryParams.startDate = this.wageMonthRange[0]
          this.queryParams.endDate = this.wageMonthRange[1]
        } else {
          this.queryParams.startDate = undefined
          this.queryParams.endDate = undefined
        }
        api.selectDataForSalaryDetail(this.queryParams).then(res => {
          const data = res.data.data
          data.customList.forEach(item => {
            item.minWidth = 140
            if (item.field === 'empName' || item.field === 'identityNum') {
              item.fixed = 'left'
              item.filterType = 'input'
            }
          })
          this.columns = data.customList
          data.translates.forEach(item => {
            if (item.dictMap != undefined) {
              this.dictMap[item.field] = this.$arrayToObj(item.dictMap, 'codeItemId')
            }
          })
          if (!this.dictMap.taxType) {
            this.dictMap.taxType = this.$arrayToObj(data.taxType, 'codeItemId')
          }
          this.tableData = this.$handleTableDict(data.dataList, this.dictMap, '')
          this.taxGroupCountList = data.taxGroupCountList
          this.queryParams.total = data.params.total
          this.dictData.costCenter = data.costCenter
          this.dictData.taxType = data.taxType
          this.render = true
          this.loading = false
        })
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData}
        this.getData()
      },
      changeTab(tab) {
        this.queryParams.page = 1
        this.queryParams.taxType = this.taxGroupCountList[tab.index].taxType
        this.getData()
      },
      getEmpList() {
        queryEmpInfoListPage({cusId: this.$userInfo.cusId, limit: 100000}).then(res => {
          this.dictData.emp = res.data.records
        })
      },
      handleSelect() {
        this.getData()
      },
      handleSelectChange(val) {
        if (this.$isEmpty(val)) {
          // 如果val为空数组，则说明触发了清空，此时不会触发visible-change事件，需要手动查询后端
          this.getData()
          this.isSelectChange = false
        } else {
          this.isSelectChange = true
        }
      },
      handleSelectVisibleChange(val) {
        // 多选的blur无法触发，而change事件触发又过于频繁，因此此处使用visible-change，即多选后下拉框消失才会查询后端数据
        if (!val && this.isSelectChange) {
          this.getData()
          // 为了防止查询条件未变化时下拉框消失也查询后端，用此标识来记录select是否有变化，并在此处重置
          this.isSelectChange = false
        }
      },
      saveCustomHeader() {
        if (this.$isEmpty(this.headerList)) {
          this.$msgError('显示项目不能为空')
          return
        }
        let param = {
          headers: this.headerList,
          reportType: '员工收入明细表'
        }
        this.submitLoading = true
        updataCustHeaderInfo(param).then(res => {
          if (res.data.code === 0) {
            this.customHeaderModalShow = false
            this.$msgSuccess('保存成功')
            this.getData()
          }
        }).finally(() => this.submitLoading = false)
      },
      handleExport() {
        api.getSalaryDataByTabsDownload(this.queryParams).then(res => {
          let fileId = res.data.downloadPath;
          let randomNum = randomLenNum("16", new Date());
          if (fileId) {
            downloadFileByUrl(fileId, randomNum + '.xlsx')
          }
        })
        this.$message.success('下载中，请稍等!');
      },
      // 客户筛选change事件
      cusChange({data, checkedLabels, checkedValues}) {
        this.queryParams.cusIds = checkedValues;
        this.getData();
      },
      numToArray(list, field) {
        return list.map(item => {
          return validatenull(item[field]) ? 0 : item[field];
        })
      },
      sumNum(list, field) {
        const numArray = this.numToArray(list, field);
        return floatSumArray(numArray);
      },
      footerMethod({columns, data}) {
        let _this = this;
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            } else {
              if (!validatenull(column.params)) {
                const {valueType} = column.params;
                if (valueType == '92420001' || valueType == '92420002') {
                  return this.sumNum(data, column.property)
                }
                return null
              } else {
                return null
              }
            }
          })
        ]
      },
      // 输入框回车，调接口
      pageSizeChange(val) {
        this.queryParams = Object.assign(val);
        this.getData();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";


</style>
